/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import './TopBar.scss';

import { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { faAngleLeft, faBars } from '@fortawesome/pro-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router';

import { colors } from '@/Themes/Colors';
import useScreenType from '@/hooks/util/useScreenType';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import { setMenuOpened } from '@/_store/modules/layout';
import {
  selectMenuOpened,
  selectRouteActive,
} from '@/_store/modules/layout/selectors';

function TopBar() {
  const dispatch = useAppDispatch();

  const isMobile = useScreenType('mobile');

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const menuOpened = useAppSelector(selectMenuOpened);
  const routeActive = useAppSelector(selectRouteActive);

  const renderButton = (icon: IconDefinition, onClick?: any) => (
    <div className="button" onClick={onClick}>
      <FontAwesomeIcon
        icon={icon}
        color={colors.white}
        size="lg"
        style={{ fontSize: '1.6em' }}
      />
    </div>
  );

  const renderRouteInfo = useCallback(() => {
    if (pathname === '/tarifas/municipio/criar') {
      return (
        <div className="subtitle1 back-label" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faAngleLeft} size="lg" />
          <span>Criar tarifa cidade</span>
        </div>
      );
    }

    if (pathname === '/tarifas/estabelecimento/criar') {
      return (
        <div className="subtitle1 back-label" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faAngleLeft} size="lg" />
          <span>Criar tarifa estabelecimento</span>
        </div>
      );
    }

    if (pathname.includes('/tarifas/municipio/editar')) {
      return (
        <div className="subtitle1 back-label" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faAngleLeft} size="lg" />
          <span>Atualizar tarifa cidade</span>
        </div>
      );
    }

    if (pathname.includes('/tarifas/estabelecimento/editar')) {
      return (
        <div className="subtitle1 back-label" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faAngleLeft} size="lg" />
          <span>Atualizar tarifa estabelecimento</span>
        </div>
      );
    }

    if (pathname.includes('/tarifas/')) {
      return (
        <div className="subtitle1 back-label" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faAngleLeft} size="lg" />
          <span>Tarifas estabelecimento</span>
        </div>
      );
    }

    return <div className="subtitle1">{routeActive?.title}</div>;
  }, [routeActive]);

  function renderTopBarMobile() {
    const renderButtonsTopRight = () => {
      return renderButton(faBars, () => {
        dispatch(setMenuOpened(!menuOpened));
      });
      /* {renderButton(faBell)} */
    };

    return (
      <div className="top-bar">
        <div className="bar show">
          <div className="route">{renderRouteInfo()}</div>
          <div className="buttons">{renderButtonsTopRight()}</div>
        </div>
      </div>
    );
  }

  function renderTopBarComputer() {
    return (
      <div className="top-bar">
        <div className={`bar show `}>
          <div className="route">{renderRouteInfo()}</div>
        </div>
      </div>
    );
  }

  return <>{isMobile ? renderTopBarMobile() : renderTopBarComputer()}</>;
}

export default TopBar;
